import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, OnDestroy, inject} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, NgbTypeahead, NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../core/services/event.service';
import { AutocompleteService } from '../../../core/services/autocomplete.service';
import { CommonAlertComponent } from '../common-alert/common-alert.component';
import { Observable, of, OperatorFunction, Subscription} from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { Options, ChangeContext, NgxSliderModule } from '@angular-slider/ngx-slider';
import { PhotoCaptureModalComponent } from '../photo-capture-modal/photo-capture-modal.component';
import { VideoRecordModalComponent } from '../video-record-modal/video-record-modal.component';
import { ConfirmAlertComponent } from '../confirm-alert/confirm-alert.component';
import { CitySuggestionComponent } from '../city-suggestion/city-suggestion.component';
import { InputRestrictionDirective } from '../../directives/input-restriction.directive';
import { FormsModule } from '@angular/forms';
import { NgClass, DecimalPipe } from '@angular/common';
import { FileSizeExceedAlertComponent } from '../file-size-exceed-alert/file-size-exceed-alert.component';
import { ImageCropModalComponent } from '../image-crop-modal/image-crop-modal.component';
import { SavingOverlayComponent } from '../saving-overlay/saving-overlay.component';
import { InfoHintComponent } from '../info-hint/info-hint.component';
import { ScrollSelectComponent, ScrollSelectOption } from '../scroll-select/scroll-select.component';

@Component({
    selector: 'edit-profile-modal',
    templateUrl: './edit-profile-modal.component.html',
    styleUrls: ['./edit-profile-modal.component.scss'],
    imports: [InfoHintComponent, NgClass, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, FormsModule, InputRestrictionDirective, NgbTypeahead, NgxSliderModule, CitySuggestionComponent, DecimalPipe, SavingOverlayComponent, NgbHighlight, ScrollSelectComponent]
})
export class EditProfileModalComponent implements OnInit, AfterViewInit, OnDestroy {
	private subs = new Subscription();


	@Input() data: any;
	@Input() basicInfo: any;
	@Input() inlineMode: boolean = false;
	/** Owned by the parent: true while the profile update request is in flight. */
	@Input() saving: boolean = false;
	@Output() updateProfile: EventEmitter<any> = new EventEmitter<any>();
	@Output() closeRequested: EventEmitter<void> = new EventEmitter<void>();

	private videoData: any;
	private imageData: any;

	public posSelected: boolean = false;
	public muteClassAdd: boolean = true;
	public videoEditted: boolean = false;
	public photoEditted: boolean = false;

	public minValue: number = 8;
	public maxValue: number = 200;
	public firstName: string = '';
	public lastName: string = '';
	public showPositionError: boolean = false;
	public positionErrorMessage: string = '';
	public showCityError: boolean = false;
	public cityErrorMessage: string = '';
	public showFirstNameError: boolean = false;
	public showLastNameError: boolean = false;
	public AvailabilityError: boolean = false;

	/** Shared with the edit-profile form; kept as strings because the API and the
	 *  existing '-1' unselected sentinel are both string-typed. */
	public workAuthOptions: ScrollSelectOption[] = [
		{ value: '1', label: 'US Citizen' },
		{ value: '2', label: 'Green Card Holder' },
		{ value: '3', label: 'Employment Authorization' },
		{ value: '4', label: 'Have H1 Visa' },
		{ value: '5', label: 'Need H1 Visa' },
		{ value: '6', label: 'Canadian Citizen' },
		{ value: '7', label: 'TN Permit Holder' }
	];
	public availabilityOptions: ScrollSelectOption[] = [
		{ value: '7', label: 'Open' },
		{ value: '1', label: 'Immediate' },
		{ value: '2', label: 'In Two Weeks' },
		{ value: '3', label: 'In a Month' },
		{ value: '4', label: 'In Two Months' },
		{ value: '5', label: 'After Two Months' },
		{ value: '6', label: 'Not Available' }
	];
	public position: string = '';
	public optionalPosition1: string = '';
	public optionalPosition2: string = '';
	public citystring = '';
	public workAuthError: boolean = false;
	public workAuth: string = '1';
	public Availability: string = '7';
	public willRelocate: boolean = false;
	public sharePicture: boolean = true;

	public id: any;
	public positionId: any;
	public optionalPositionId1: any;
	public optionalPositionId2: any;
	public city: any;
	public selectedPhoto: any;
	public photoSelected: boolean = false;
	public selectedVideoUrl: any;
	public videoSelected: boolean = false;
	public intern: boolean = false;
	public contract: boolean = false;
	public fullTime: boolean = false;
	public Volunteer: boolean = false;
	public showAddtolist: boolean = true;
	public suggestions: any[] = [];
	public showpositionAddtolist: boolean = true;
	public firstNameSelected: boolean = false;
	public lastNameSelected: boolean = false;
	public rawVideoUrl: string = '';

	public parentobj: any = {
		position: '',
		city: '',
		showPositionError: '',
		showCityError: ''
	};

	public salarySlider = {
		minValue: this.minValue,
		maxValue: this.maxValue,
		options: {
			floor: 8,
			ceil: 600,
			step: 1,
			minLimit: 8,
			maxLimit: 600
		} as Options,
		onChange: (changeContext: ChangeContext) => {
			this.valueUpdated = true;
			this.minValue = changeContext.value;
			this.maxValue = changeContext.highValue || 0;
			this.valueUpdated = true;
		}
	};

	public valueUpdated: boolean = false;
	/** Serialized form state as it was loaded, used to gray out Save until something actually changes. */
	private pristineSnapshot: string = '';

	public modal = inject(NgbActiveModal, { optional: true }) as NgbActiveModal;

	constructor(
		private sanitizer: DomSanitizer,
		private autocompleteService: AutocompleteService,
		private eventService: EventService,
		private modalService: NgbModal) { }

	ngOnInit() {
		if (this.basicInfo) {
			let obj = this.basicInfo;
			this.id = obj.UserId;
			this.firstName = obj.FirstName;
			this.lastName = obj.LastName;
			this.positionId = obj.JobTitleId;
			this.position = obj.JobTitle;
			this.optionalPositionId1 = obj.optionalTitleId1;
			this.optionalPosition1 = obj.JobTitle1;
			this.optionalPositionId2 = obj.optionalTitleId2;
			this.optionalPosition2 = obj.JobTitle2;
			this.maxValue = obj.EndPay;
			this.minValue = obj.StartPay;

			this.salarySlider.minValue = this.minValue;
			this.salarySlider.maxValue = this.maxValue;

			this.city = obj.Location;
			this.workAuth = obj.WorkType.toString();
			this.Availability = obj.Availability ? obj.Availability.toString() : '-1';
			this.willRelocate = obj.WillingToRelocate;
			this.sharePicture = obj.shareProfilePic;
			if (obj.isDPVideo === 0) {
				this.selectedPhoto = obj.DpUrl;
				this.photoSelected = true;
			} else {
				this.selectedVideoUrl = obj.DpUrl;
				this.videoSelected = true;
			}

			obj.JobTypes.forEach((value: number) => {
				if (value === 0) {
					this.intern = true;
				} else if (value === 1) {
					this.contract = true;
				} else if (value === 2) {
					this.fullTime = true;
				} else if (value === 3) {
					this.Volunteer = true;
				}
			});
		}

		// baseline for the dirty check, taken after the form is populated
		this.pristineSnapshot = this.currentSnapshot();

		this.subs.add(this.eventService.subscribe('video-selected', (value) => {
			// video selected
			this.muteClassAdd = true;
			this.videoEditted = true;
			this.photoSelected = false;
			this.videoSelected = true;
			this.sharePicture = true;
			this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(value.data.url);
			this.rawVideoUrl = value.data.url;
			this.videoData = value.data.videoData;
			this.valueUpdated = true;
			// defer until Angular renders the @if block
			setTimeout(() => this.muted(true), 0);
		}));

	}

	ngAfterViewInit() {
		this.muted(true);
		//
	}

	muted(val: boolean) {
		if (document.getElementById('vidPreview')) {
			if (val !== undefined && val !== null) {
				(document.getElementById('vidPreview') as HTMLMediaElement).muted = val;
				this.muteClassAdd = val;
			}
		}
	}

	positionVideo() {
		let selectedVideo = (document.querySelector('#vidPreview') as HTMLElement);
		let leftMargin = ((selectedVideo.offsetWidth - selectedVideo.offsetHeight) / 2) * -1;
		(document.getElementById('vidPreview') as HTMLElement).style.marginLeft = `${leftMargin}px`;
		if (!this.videoEditted) {
			this.muted(true);
		}
	}

	positionPhoto() {
		let selectedVideo = (document.querySelector('.imgPreview') as HTMLElement);
		let leftMargin = ((selectedVideo.offsetWidth - selectedVideo.offsetHeight) / 2) * -1;
		(document.getElementById('imgPreview') as HTMLElement).style.marginLeft = `${leftMargin}px`;
	}

	roundSalRange(val: number) {
		return Math.round((((val * 8 * 20 * 12) / 1000) * 10) / 10);
	}


	recordVideo() {

		this.muteClassAdd = true;
		this.muted(true);
    this.sharePicture=true;
		// Delay modal opening slightly
		setTimeout(() => {
			this.modalService.open(VideoRecordModalComponent,
				{ windowClass: 'modal-theme-unnanu-v2 video-recorder-popup', backdrop: 'static', keyboard: false });
		}, 50);


	}


	takePhotoDialog(event?: KeyboardEvent | MouseEvent) {
		event?.preventDefault();
		this.muted(true);
		const modal = this.modalService.open(PhotoCaptureModalComponent, {
			windowClass: 'modal-theme-unnanu-v2 video-recorder-popup',
			backdrop: 'static',
			keyboard: false
		});
		modal.result.then((photoData: string) => {
			if (photoData) {
				this.openCropModal(photoData);
			}
		}, () => {});
	}


	filePicked(event: Event) {
		const inputElement = event.target as HTMLInputElement;

		if (inputElement.files && inputElement.files.length > 0) {
		  const file = inputElement.files[0];

		  const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
		  if (!allowedImageTypes.includes(file.type)) {
			const modal = this.modalService.open(FileSizeExceedAlertComponent, { windowClass: 'alert-popup-common', backdrop: 'static', keyboard: false });
			modal.componentInstance.msg = 'Only JPG, JPEG, and PNG images are allowed.';
			inputElement.value = '';
			return;
		  }

		  const reader = new FileReader();
		  reader.onload = () => {
			const base64 = reader.result as string;
			inputElement.value = '';
			this.openCropModal(base64);
		  };
		  reader.readAsDataURL(file);
		}
	  }

	private openCropModal(base64: string) {
		const cropModal = this.modalService.open(ImageCropModalComponent, {
			windowClass: 'modal-theme-unnanu-v2 image-crop-popup',
			backdrop: 'static',
			keyboard: false,
			size: 'lg'
		});
		cropModal.componentInstance.imageBase64 = base64;
		cropModal.result.then((croppedBase64: string) => {
			if (croppedBase64) {
				this.selectedPhoto = croppedBase64;
				this.imageData = croppedBase64;
				this.photoSelected = true;
				this.videoSelected = false;
				this.photoEditted = true;
				this.sharePicture = true;
				this.valueUpdated = true;
				this.muted(true);
			}
		}, () => {});
	}

	positionSelectedImage(val?: any) {
		if (val === undefined) {
			val = 1;
		}
		if (val !== 0) {
			let parent = (document.querySelector('.photo-video-container') as HTMLElement);
			let selectedImg = (document.querySelector('.capturePhoto') as HTMLElement);

			let leftMargin;
			if (selectedImg !== null) {
				leftMargin = ((parent.offsetWidth - selectedImg.offsetWidth) / 2) * val;
			} else {
				leftMargin = (parent.offsetWidth / 2) * val;
			}

			if (document.getElementById('capturePhoto') !== null) {
				(document.getElementById('capturePhoto') as HTMLElement).style.marginLeft = `${leftMargin}px`;
			}
		} else {
			(document.getElementById('capturePhoto') as HTMLElement).style.marginLeft = '-21px';
		}
	}

	suggestPositions(term: string) {
		this.validatePosition();
		if (term.length >= 3) {
			this.showAddtolist = false;
			return this.autocompleteService.get(term, 'profession').pipe(map((response: any) => {
				if (
					response.status === 200 &&
					response.Code === 200 &&
					response.Data.length > 0
				) {
					this.suggestions = response.Data;
					return this.suggestions.slice(0, 10);
				} else {
					// Add New Position
					this.suggestions = [];
					return this.suggestions.slice(0, 10);
				}
			})
			);
		} else {
			this.showAddtolist = false;
			return of([]);
		}
	}

	search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(term => this.suggestPositions(term).pipe(catchError(() => of([]))))
		)

	formatter = (result: any) => result.Name;

	positionSelected(event: any) {
		event.preventDefault();
		let positionName = event.item.Name;
		let id = event.item.Id;
		if (positionName !== '') {
			this.posSelected = true;
			this.position = positionName;
			this.positionId = id;
			this.showAddtolist = false;
			this.showpositionAddtolist = false;
		} else {
			this.position = '';
		}
		this.showpositionAddtolist = false;
	}

	search1: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(term => this.suggestPositions(term).pipe(catchError(() => of([]))))
		)

	opPositionSelected1(event: any) {
		event.preventDefault();
		let positionName = event.item.Name;
		let id = event.item.Id;
		if (positionName !== '') {
			this.optionalPosition1 = positionName;
			this.optionalPositionId1 = id;
		} else {
			this.optionalPosition1 = '';
		}
	}

	search2: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(term => this.suggestPositions(term).pipe(catchError(() => of([]))))
		)

	opPositionSelected2(event: any) {
		event.preventDefault();
		let positionName = event.item.Name;
		let id = event.item.Id;
		if (positionName !== '') {
			this.optionalPosition2 = positionName;
			this.optionalPositionId2 = id;
		} else {
			this.optionalPosition2 = '';
		}
	}

	validateFirstName() {
		if (this.firstName.length > 0) {
			this.firstNameSelected = true;
			this.showFirstNameError = false;
		} else {
			this.firstNameSelected = false;
			this.showFirstNameError = true;
		}
	}

	validateLastName() {
		if (this.lastName.length > 0) {
			this.lastNameSelected = true;
			this.showLastNameError = false;
		} else {
			this.lastNameSelected = false;
			this.showLastNameError = true;
		}
	}

	validatePosition() {
		if (this.parentobj.position === '' && this.position === '') {
			this.positionErrorMessage = 'Please select your position';
			this.showPositionError = true;
		} else {
			this.showPositionError = false;
		}
	}

	validateCity() {
		if (this.parentobj.city === '' && this.city === '') {
			this.cityErrorMessage = 'Please select a City';
			this.showCityError = true;
		} else {
			this.showCityError = false;
		}
	}

	validateWorkAuth() {
		if (this.workAuth !== '-1') {
			this.workAuthError = false;
		} else {
			this.workAuthError = true;
		}
	}

	validateAvailability() {
		if (this.Availability !== '-1') {
			this.AvailabilityError = false;
		} else {
			this.AvailabilityError = true;
		}
	}

	saveData() {
		if (this.saving) {
			return;
		}

		this.validateFirstName();
		this.validateLastName();
		this.validateWorkAuth();
		this.validateAvailability();

		this.firstName = this.firstName.trim();
	this.lastName = this.lastName.trim();
		if (
			this.workAuthError ||
			this.AvailabilityError ||
			this.showFirstNameError ||
			this.showLastNameError ||
			this.parentobj.showPositionError ||
			this.parentobj.showCityError ||
			!(this.fullTime || this.intern || this.contract || this.Volunteer)
		) {
			let modal = this.modalService.open(CommonAlertComponent, { backdrop: 'static', keyboard: false });
			modal.componentInstance.msg = 'Fill all required fields.';
		} else {
			let jobTypes = [];
			if (this.fullTime) jobTypes.push(2);
			if (this.contract) jobTypes.push(1);
			if (this.intern) jobTypes.push(0);
			if (this.Volunteer) jobTypes.push(3);

			let objToUpload = {
				UpdateRecords: [
					{
						Type: 'BASIC',
						Data: {
							FirstName: this.firstName,
							LastName: this.lastName,
							FullName: `${this.firstName} ${this.lastName}`,
							UserId: this.id,
							JobTitleId:
								this.parentobj.position !== ''
									? this.parentobj.position
									: this.position,
							JobTitle1: this.optionalPosition1,
							JobTitle2: this.optionalPosition2,
							DpUrl: '',
							StartPay: this.minValue,
							EndPay: this.maxValue,
							JobTypes: jobTypes,
							Availability: this.Availability,
							WorkType: this.workAuth,
							Location:
								this.parentobj.city !== ''
									? this.parentobj.city
									: this.city,
							WillingToRelocate: this.willRelocate,
							shareProfilePic: this.sharePicture,
						},
					},
				],
			};

			if (this.videoEditted) {
				this.updateProfile.emit({ objToUpload: objToUpload, isVideo: true, isMediaModified: true, mediaData: this.videoData });
				this.basicInfo.isDPVideo = 1;
				this.basicInfo.DpUrl = this.selectedVideoUrl;
			} else if (this.photoEditted) {
				this.updateProfile.emit({ objToUpload: objToUpload, isVideo: false, isMediaModified: true, mediaData: this.imageData });
				this.basicInfo.isDPVideo = 0;
				this.basicInfo.DpUrl = this.selectedPhoto;
			} else if (!this.sharePicture){
				this.basicInfo.isDPVideo = 0;
				this.basicInfo.DpUrl = '../../../assets/images/default-profile-picture-thumb.svg';
				this.updateProfile.emit({ objToUpload: objToUpload, isVideo: false, isMediaModified: false, mediaData: undefined });
			}
			else {
				this.updateProfile.emit({ objToUpload: objToUpload, isVideo: false, isMediaModified: false, mediaData: undefined });
			}

			this.basicInfo.EndPay = this.maxValue;
			this.basicInfo.FirstName = this.firstName;
			this.basicInfo.LastName = this.lastName;
			this.basicInfo.FullName = `${this.firstName} ${this.lastName}`;
			this.basicInfo.JobTitle =
				this.parentobj.position !== ''
					? this.parentobj.position
					: this.position;
			this.basicInfo.JobTitle1 = this.optionalPosition1;
			this.basicInfo.JobTitle2 = this.optionalPosition2;
			this.basicInfo.JobTitleId = this.positionId;
			this.basicInfo.optionalTitleId1 = this.optionalPositionId1;
			this.basicInfo.optionalTitleId2 = this.optionalPositionId2;
			this.basicInfo.JobTypes = jobTypes;
			this.basicInfo.Location =
				this.parentobj.city !== '' ? this.parentobj.city : this.city;
			this.basicInfo.StartPay = this.minValue;
			this.basicInfo.WorkType = this.workAuth;
			this.basicInfo.Availability = this.Availability;
			this.basicInfo.WillingToRelocate = this.willRelocate;
			this.basicInfo.shareProfilePic = this.sharePicture;

			// what we just sent is the new "unchanged" state, so Save grays out again
			this.pristineSnapshot = this.currentSnapshot();
			this.photoEditted = false;
			this.videoEditted = false;
			this.valueUpdated = false;
		}
	}

	/**
	 * Everything saveData() sends, in the same resolved form, so the comparison
	 * tracks the data actually being saved rather than raw widget state.
	 */
	private currentSnapshot(): string {
		return JSON.stringify({
			firstName: (this.firstName || '').trim(),
			lastName: (this.lastName || '').trim(),
			position: this.parentobj.position !== '' ? this.parentobj.position : this.position,
			optionalPosition1: this.optionalPosition1 || '',
			optionalPosition2: this.optionalPosition2 || '',
			minValue: this.minValue,
			maxValue: this.maxValue,
			fullTime: !!this.fullTime,
			contract: !!this.contract,
			intern: !!this.intern,
			volunteer: !!this.Volunteer,
			workAuth: this.workAuth,
			availability: this.Availability,
			city: this.parentobj.city !== '' ? this.parentobj.city : this.city,
			willRelocate: !!this.willRelocate,
			sharePicture: !!this.sharePicture
		});
	}

	/**
	 * True once the form differs from how it was loaded. Photo/video edits are
	 * tracked by their own flags because the media itself is not comparable here.
	 */
	get isDirty(): boolean {
		if (this.photoEditted || this.videoEditted) {
			return true;
		}
		return this.currentSnapshot() !== this.pristineSnapshot;
	}

	onChange(_event: any){
		this.valueUpdated = true;
	}

	onChangeShare(checked: boolean) {
    if (!checked) {
      let modal = this.modalService.open(ConfirmAlertComponent, {backdrop: 'static', keyboard: false });
			modal.componentInstance.header = 'Remove profile video or picture:';
			modal.componentInstance.msg = 'This will remove your profile video or picture from your profile. You will need to re-record or upload a new picture. Are you sure you want to proceed?';
			modal.result.then(() => {
				this.sharePicture = false;
				this.selectedPhoto = '';
				this.photoSelected = false;
				this.selectedVideoUrl = '';
				this.videoSelected = false;
			},
				() => {
					this.sharePicture = true;
				});
    }
		this.valueUpdated = true;
	}

	close() {
		if (this.inlineMode) {
			this.closeRequested.emit();
		} else if (this.modal) {
			this.modal.dismiss();
		}
	}


	deleteImage() {
		this.selectedPhoto = '';
		this.photoSelected = false;
		this.photoEditted = false;
		this.videoSelected = false;
		this.videoEditted = false;
		this.imageData = null;
		this.videoData = null;
		this.sharePicture = false;
		this.valueUpdated = true;
		this.muted(true);
	}


	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
